import React from "react";
import { NodeProps, useReactFlow } from "reactflow";
import styled from "styled-components";
import { operationType } from "../../../../services/types";
import { updateNodeValue } from "../../../../services/method";
import { Textarea } from "../../../form/textarea";
import { TextInput } from "../../../form/textInput";
import { SettingsBlock, settingsDataType } from "../../../settingsBlock";
import { IoCheckmarkCircleOutline, IoWarningOutline } from "react-icons/io5";
import { ExpandedBlock } from "../../expanded";

type JevClassifierProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function JevClassifier({ id, data, setChildMinimize, setChildSettings }: JevClassifierProps) {
   const { setNodes } = useReactFlow();
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);

   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   React.useEffect(() => {
      if (data.value?.threshold === undefined || data.value?.threshold === '') {
         updateNodeValue(id, setNodes, { threshold: '0.8' });
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, keyRef?: string) => {
      if (keyRef) updateNodeValue(id, setNodes, { [keyRef]: e.target.value });
   };

   const isWarning = false;

   return (<>
      <SettingsBlock nodeId={ id } data={ settings } setData={ setSettings } />
      <Main>
         {isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={21} /></span>
         </> : data.output ? <>
            <div id="ran"></div>
            <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
         </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }}
            handleClose={ () => setIsExpanded(false) }
            isWarning={ isWarning }
            style={{ minWidth: '350px' }}
         ><Styled>
            <Textarea
               keyRef="value"
               value={ data.value?.value || '' }
               placeholder={'One class per line. The Class output is the chosen label.\ncharged twice\nrefund request\npassword reset'}
               handleChange={ handleChangeInput }
            />
            <TextInput
               keyRef="threshold"
               title="Low confidence below"
               value={data.value?.threshold === undefined || data.value?.threshold === '' ? '0.8' : String(data.value.threshold)}
               placeholder="0.8"
               type="number"
               min={0}
               max={1}
               step={0.05}
               handleChange={handleChangeInput}
            />
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}

const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

const Styled = styled.div`
   .textarea {
      textarea {
         padding: 7.5px;
         font-size: 15px;
         min-height: 120px;
      }
   }
   .textInput.threshold {
      margin-top: 12px;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 6px;

      h4 {
         width: auto;
         max-width: none;
         white-space: normal;
         line-height: 1.35;
         margin: 0;
         font-size: 13px;
         color: #4b5563;
      }

      > div {
         width: 120px;
         max-width: 100%;
      }
   }
`;
